var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { FieldCheckbox } from "../../";

var CheckboxWidget = (_temp2 = _class = function (_Component) {
    _inherits(CheckboxWidget, _Component);

    function CheckboxWidget() {
        var _temp, _this, _ret;

        _classCallCheck(this, CheckboxWidget);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.schemaRequiresTrueValue = function (schema) {
            // Check if const is a truthy value
            if (schema.const) {
                return true;
            }

            // Check if an enum has a single value of true
            if (schema.enum && schema.enum.length === 1 && schema.enum[0] === true) {
                return true;
            }

            // If anyOf has a single value, evaluate the subschema
            if (schema.anyOf && schema.anyOf.length === 1) {
                return _this.schemaRequiresTrueValue(schema.anyOf[0]);
            }

            // If oneOf has a single value, evaluate the subschema
            if (schema.oneOf && schema.oneOf.length === 1) {
                return _this.schemaRequiresTrueValue(schema.oneOf[0]);
            }

            // Evaluate each subschema in allOf, to see if one of them requires a true
            // value
            if (schema.allOf) {
                return schema.allOf.some(_this.schemaRequiresTrueValue);
            }
        }, _this.onFocus = function (event) {
            if (_this.props.onFocus) {
                _this.props.onFocus(_this.props.id, event.target.value);
            }
        }, _this.onBlur = function (event) {
            if (_this.props.onBlur) {
                _this.props.onBlur(_this.props.id, event.target.value);
            }
        }, _this.onChange = function (value, event) {
            _this.props.onChange(value);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    CheckboxWidget.prototype.render = function render() {
        var _props = this.props,
            id = _props.id,
            schema = _props.schema,
            value = _props.value,
            disabled = _props.disabled,
            readonly = _props.readonly,
            multiple = _props.multiple,
            autofocus = _props.autofocus;


        var required = this.schemaRequiresTrueValue(schema);

        return React.createElement(FieldCheckbox, _extends({}, this.props, {
            checked: value,
            required: required,
            onChange: this.onChange,
            onBlur: this.onBlur,
            onFocus: this.onFocus
        }));
    };

    return CheckboxWidget;
}(Component), _class.defaultProps = {
    autofocus: false,
    options: {
        inline: false
    }
}, _temp2);
CheckboxWidget.propTypes = process.env.NODE_ENV !== "production" ? {
    schema: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    options: PropTypes.shape({
        enumOptions: PropTypes.array,
        inline: PropTypes.bool
    }).isRequired,
    value: PropTypes.any,
    required: PropTypes.bool,
    readonly: PropTypes.bool,
    disabled: PropTypes.bool,
    multiple: PropTypes.bool,
    autofocus: PropTypes.bool,
    onChange: PropTypes.func
} : {};


export default CheckboxWidget;